import { defineStore } from 'pinia';
import { ref } from '@vue/composition-api';

export const useProjectStore = defineStore('project', () => {
  const selectedProject = ref<string>('0');
  const projects = ref<object>({});

  function setSelectedProject(id: string) {
    selectedProject.value = id;
  }

  function setProjects(_projects: object) {
    projects.value = _projects;
  }

  return {
    projects,
    setProjects,
    selectedProject,
    setSelectedProject,
  };
}, { persist: true });
